import Vue from "vue";
import VueRouter from "vue-router";
import QuestionView from "../views/QuestionView.vue";
import HintsView from "../views/HintsView.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: QuestionView,
  },
  {
    path: "/hints",
    name: "hints",
    component: HintsView,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
